<template>
  <div class="dizme_tm_all_wrap" data-magic-cursor="show">
    <MobileHeaderVue />
    <HeaderVue />
    <HomeComponent />
    <!-- HERO -->

    <!-- PROCESS -->
    <ProcessComponent />
    <!-- /PROCESS -->

    <!-- ABOUT -->
    <AboutComponent />
    <!-- /ABOUT -->

    <!-- FEATURES -->
    <FeaturesComponent />
    <!-- /FEATURES -->

    <!-- PRICING -->
    <PricingComponent />
    <!-- /PRICING -->

    <!-- MOBILE APPS -->
    <MobileAppComponent />
    <!-- /MOBILE APPS -->

    <!-- TESTIMONIALS -->
    <!-- <TestimonialsComponent /> -->
    <!-- /TESTIMONIALS -->

    <!-- COPYRIGHT -->
    <CopyrightComponent />
    <!-- /COPYRIGHT -->

    <ScrollTopVue />

    <DonorProAccessModal />
  </div>
</template>

<script>
import HeaderVue from "@/components/layout/Header.vue";
import MobileHeaderVue from "@/components/layout/MobileHeader.vue";
import DonorProAccessModal from "@/components/popup/DonorProAccessModal.vue";
import ScrollTopVue from "@/components/layout/ScrollTop.vue";
import { activeSkillProgress } from "@/utilits";
import AboutComponent from "../components/AboutComponent.vue";
import CopyrightComponent from "../components/CopyrightComponent.vue";
import HomeComponent from "../components/HomeComponent.vue";
import ProcessComponent from "../components/ProcessComponent.vue";
import FeaturesComponent from "../components/FeaturesComponent.vue";
import PricingComponent from "../components/PricingComponent.vue";
import MobileAppComponent from "../components/MobileAppComponent.vue";
// import TestimonialsComponent from "../components/TestimonialsComponent.vue";

export default {
  name: "IndexView",
  components: {
    HomeComponent,
    ProcessComponent,
    AboutComponent,
    FeaturesComponent,
    PricingComponent,
    MobileAppComponent,
    // TestimonialsComponent,
    CopyrightComponent,
    DonorProAccessModal,
    HeaderVue,
    MobileHeaderVue,
    ScrollTopVue,
  },
  mounted() {
    window.addEventListener("scroll", activeSkillProgress);
    this.scrollToHash();
  },
  methods: {
    // A direct load of `mypbe.com/#apps` (the link handed out with the store
    // listings) lands before the sections mount, so the browser has nothing to
    // scroll to. Do it ourselves once the page is up — after the 1500ms
    // preloader in `utilits.preloader`, which holds the page until it lifts.
    scrollToHash() {
      const id = window.location.hash.slice(1);
      if (!id) return;

      this.$nextTick(() => {
        window.setTimeout(() => {
          const target = document.getElementById(id);
          if (target) target.scrollIntoView({ behavior: "smooth" });
        }, 1700);
      });
    },
  },
};
</script>
